// extracted by mini-css-extract-plugin
module.exports = {"submmitBtn":"submmitBtn-3MI2LQOZ","errrTip":"errrTip-3eOcKEOB"};